import ReactMarkdown from 'react-markdown';
import styles from 'assets/styles/ai-chat-bot/markdownRenderer.module.css';
import { Dialog } from 'primereact/dialog';
import { Sidebar } from 'primereact/sidebar';

const DataShowModal = ({ d_id, d_data, visible, close }: any) => {
    const MarkdownRenderer = ({ content }: any) => {
        return (
            <ReactMarkdown>
                {content}
            </ReactMarkdown>
        );
    };
    return (
        <Sidebar
            className='form-sidebar'
            position="right"
            header={d_id}
            visible={visible}
            style={{ width: '810px' }}
            onHide={() => close()}
        >
            <div className='form-sidebar-body full-sidebar-body '>
                <MarkdownRenderer content={d_data} />
            </div>
        </Sidebar>
    )
}

export default DataShowModal